import marmosetCarouselIcon from 'images/marmoset_carousel.webp'

import { getImageThumbnailUrl } from './getImageThumbnailUrl'

export function getMarmosetThumbnailUrl(medias) {
  const firstImageTypeMedia = medias.find(media => media.visualType === 'ItemImage')
  if (firstImageTypeMedia) {
    return getImageThumbnailUrl(firstImageTypeMedia)
  }

  return marmosetCarouselIcon
}
